// extracted by mini-css-extract-plugin
export default {"filter":"HealthFood_filter__aEbUs","products":"HealthFood_products__I4iuK"};